// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AAoFucBaoTa7VeQaWWsv {
    background-color: #f3f4ffe6;
    position: sticky;
    top: 0;
    z-index: 100;
    padding-bottom: 1rem;
}

.tKygQ4LMDikHs5Hsh0Qk {
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 1rem;
}

.hA1xdmdw24FYk0VWYZjN,
.Gf_6B7gjXvVvPEIX_RXw {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.hA1xdmdw24FYk0VWYZjN button {
    margin: 0;
}

.hA1xdmdw24FYk0VWYZjN button,
.hA1xdmdw24FYk0VWYZjN button span {
    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);
}

.g8MpYnQVf_uFwakj0vw9 {
    display: none;
}

.vL4kBD01WOQl7ZZ5bIZp {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    background-color: #D3DAFF;
    padding: 0.5rem 1rem;
    border-radius: 32px;
    text-decoration: none;
    color: black;
    transition: 0.3s;
    margin-left: 1.5rem;
}

.vL4kBD01WOQl7ZZ5bIZp:hover {
    background-color: #b6c3ff;
}

.vL4kBD01WOQl7ZZ5bIZp span {
    font-weight: 600;
}

.fUnS8BXXQeLUzup7jb9J {
    max-width: 5rem;
}

@media screen and (max-width: 768px) {
    .vL4kBD01WOQl7ZZ5bIZp {
        display: none;
    }

    .hA1xdmdw24FYk0VWYZjN {
        display: none;
    }

    .g8MpYnQVf_uFwakj0vw9 {
        display: block;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Navigation/Navigation.module.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".background {\n    background-color: #f3f4ffe6;\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    padding-bottom: 1rem;\n}\n\n.navigation {\n    position: sticky;\n    top: 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 1rem;\n}\n\n.button-group,\n.logo-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.button-group button {\n    margin: 0;\n}\n\n.button-group button,\n.button-group button span {\n    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);\n}\n\n.mobile {\n    display: none;\n}\n\n.phone {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n    background-color: #D3DAFF;\n    padding: 0.5rem 1rem;\n    border-radius: 32px;\n    text-decoration: none;\n    color: black;\n    transition: 0.3s;\n    margin-left: 1.5rem;\n}\n\n.phone:hover {\n    background-color: #b6c3ff;\n}\n\n.phone span {\n    font-weight: 600;\n}\n\n.logo {\n    max-width: 5rem;\n}\n\n@media screen and (max-width: 768px) {\n    .phone {\n        display: none;\n    }\n\n    .button-group {\n        display: none;\n    }\n\n    .mobile {\n        display: block;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `AAoFucBaoTa7VeQaWWsv`,
	"navigation": `tKygQ4LMDikHs5Hsh0Qk`,
	"button-group": `hA1xdmdw24FYk0VWYZjN`,
	"logo-group": `Gf_6B7gjXvVvPEIX_RXw`,
	"mobile": `g8MpYnQVf_uFwakj0vw9`,
	"phone": `vL4kBD01WOQl7ZZ5bIZp`,
	"logo": `fUnS8BXXQeLUzup7jb9J`
};
export default ___CSS_LOADER_EXPORT___;
